import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MailCheck } from "lucide-react";
import { emailMetrics } from "../../api/platformRevenue";
import { NeuCard } from "../../components/neu/Neu";

const TONE = { good: "text-success", warning: "text-amber-400", critical: "text-destructive" };

// نسب التسليم والارتداد والشكاوى من CloudWatch (SES).
export const EmailMetricsCard = () => {
  const { t } = useTranslation();
  const [data, setData] = useState(null);

  useEffect(() => {
    emailMetrics().then(setData).catch(() => setData({ ok: false, error: "unreachable" }));
  }, []);

  if (!data) return null;
  const rows = [
    ["sent", data.send ?? 0],
    ["delivered", `${data.delivery_rate ?? 0}%`],
    ["bounced", `${data.bounce_rate ?? 0}%`],
    ["complaints", `${data.complaint_rate ?? 0}%`],
    ["rejected", data.reject ?? 0],
  ];

  return (
    <NeuCard data-testid="email-metrics-card">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <MailCheck className="h-5 w-5 text-primary" />
          <div>
            <h2 className="text-lg font-black">{t("emailMetrics.title")}</h2>
            <p className="text-xs text-muted-foreground">{t("emailMetrics.subtitle", { days: data.days ?? 14 })}</p>
          </div>
        </div>
        <span className={`text-xs font-bold ${TONE[data.health] || "text-muted-foreground"}`} data-testid="email-metrics-health">
          {t(`emailMetrics.health.${data.ok ? data.health : "unavailable"}`)}
        </span>
      </div>
      <div className="mt-4 grid grid-cols-2 gap-3 lg:grid-cols-5">
        {rows.map(([key, value]) => (
          <div key={key} className="neu-in rounded-2xl p-3" data-testid={`email-metric-${key}`}>
            <p className="text-[10px] tracking-normal text-muted-foreground">{t(`emailMetrics.${key}`)}</p>
            <p className="mt-1 font-mono text-sm font-semibold">{data.ok ? value : "—"}</p>
          </div>
        ))}
      </div>
      {!data.ok ? (
        <p className="mt-3 text-xs text-muted-foreground" data-testid="email-metrics-note">
          {t("emailMetrics.blocked")}
          <span className="mx-1 font-mono">cloudwatch:GetMetricStatistics</span>
        </p>
      ) : null}
    </NeuCard>
  );
};
